module.exports = __webpack_public_path__ + "static/media/placeholder.c94c055b.svg";